module.exports = __webpack_public_path__ + "static/media/infowall.72232c20.png";